var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-container",on:{"click":_vm.change}},[_c('div',{staticClass:"checkbox-itself",class:[{'checked' : _vm.is_true}, {white: _vm.whiteCheck}]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }